"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLoading = void 0;
const react_1 = __importDefault(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const Backdrop_1 = __importDefault(require("@material-ui/core/Backdrop"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const styles_1 = require("@material-ui/core/styles");
const useStyles = styles_1.makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));
function PageLoading({ text }) {
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Backdrop_1.default, { open: true, className: classes.backdrop },
            react_1.default.createElement(Box_1.default, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" },
                react_1.default.createElement(Typography_1.default, { variant: "h5", color: "primary" }, text),
                react_1.default.createElement(CircularProgress_1.default, { size: 50 })))));
}
exports.PageLoading = PageLoading;
